import React, { useState } from 'react';
import { Routing } from '..';
import {
	AppContextProvider,
	AuthContextProvider,
	BrowserContexProvider,
} from '../../context';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import './app.scss';

function App({ rootEl }) {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						refetchOnWindowFocus: false,
						retry: false,
					},
				},
			})
	);

	return (
		<>
			<QueryClientProvider client={queryClient}>
				<AppContextProvider rootEl={rootEl}>
					<AuthContextProvider>
						<BrowserContexProvider>
							<LocalizationProvider dateAdapter={AdapterMoment}>
								<div className="App">
									<Routing />
								</div>
							</LocalizationProvider>
						</BrowserContexProvider>
					</AuthContextProvider>
				</AppContextProvider>
			</QueryClientProvider>
		</>
	);
}

export default App;
